import React from 'react'
import { toast } from 'react-toastify'
import { useSelector, useDispatch } from 'react-redux'
import { logout } from 'redux/auth/actions'
import { gotoUrl, isUserLogged } from 'utils/functions'

import { ROUTE_CONSTANTS } from 'utils/constants/routeConstants'
import { useLocation } from 'react-router'
import jwtDecode from 'jwt-decode'

const SecuredRoute = ({ parent: Parent, child, ...rest }) => {
  const dispatch = useDispatch()
  
  const accessToken = useSelector(state => state.auth.access_token)
  if (!accessToken) gotoUrl(ROUTE_CONSTANTS.LOGIN)
  const email = jwtDecode(accessToken)?.sub
  
  const location = useLocation()
  const from = `${location.pathname}${location.search}` 
  
  if (isUserLogged(accessToken)) {
    return <Parent component={child} {...rest} />
  } 

  if (accessToken) {
    toast.warn('Seu acesso expirou, faça login novamente.')
    dispatch(logout())
    gotoUrl(ROUTE_CONSTANTS.LOGIN, from, email)
  } else {
    gotoUrl(ROUTE_CONSTANTS.LOGIN)
  }
  
  return null
}

export default SecuredRoute
